import { server } from "@/api";

export const paginate = async (params) => {
    return await server().get('api/categories', { params });
}

export const all = async (params) => {
    return await server().get('api/categories', { params: { all: true, ...params } });
}

export const create = async (category) => {
    return await server().post('api/categories', category);
}

export const update = async (id, category) => {
    return await server().post(`api/categories/${id}`, category);
}

export const remove = async (id) => {
    return await server().delete(`api/categories/${id}`);
}

export default { paginate, all, create, update, remove };
